import application from "./application/reducers";

export const rootReducer = {
  app: application,
};
